export const VALIDATE_INFORMATION_CONTRIBUTOR = `/inscriptions/registration-request/pre-registration/create`
export const VALIDATE_INFORMATION_PROVIDER = `/preinscription`
